/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddPvdConfigRequest
 */
export interface AddPvdConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof AddPvdConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof AddPvdConfigRequest
     */
    spec_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    is_compass_core: boolean;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof AddPvdConfigRequest
     */
    voltage_allowed_settings: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_voltage_allowed: boolean;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof AddPvdConfigRequest
     */
    current_allowed_settings: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_current_allowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_shared_auto_adapt_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_shared_auto_adapt_locked_to_value: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_voltage_next_alert_size_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_voltage_next_alert_size_locked_to_value: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_current_next_alert_size_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    adaptive_current_next_alert_size_locked_to_value: boolean;
    /**
     * 
     * @type {number}
     * @memberof AddPvdConfigRequest
     */
    adaptive_voltage_max_setting: number;
    /**
     * 
     * @type {number}
     * @memberof AddPvdConfigRequest
     */
    adaptive_voltage_min_setting: number;
    /**
     * 
     * @type {number}
     * @memberof AddPvdConfigRequest
     */
    adaptive_current_max_setting: number;
    /**
     * 
     * @type {number}
     * @memberof AddPvdConfigRequest
     */
    adaptive_current_min_setting: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddPvdConfigRequest
     */
    should_force_apply_this_update: boolean;
}

/**
 * Check if a given object implements the AddPvdConfigRequest interface.
 */
export function instanceOfAddPvdConfigRequest(value: object): value is AddPvdConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('is_compass_core' in value) || value['is_compass_core'] === undefined) return false;
    if (!('voltage_allowed_settings' in value) || value['voltage_allowed_settings'] === undefined) return false;
    if (!('adaptive_voltage_allowed' in value) || value['adaptive_voltage_allowed'] === undefined) return false;
    if (!('current_allowed_settings' in value) || value['current_allowed_settings'] === undefined) return false;
    if (!('adaptive_current_allowed' in value) || value['adaptive_current_allowed'] === undefined) return false;
    if (!('adaptive_shared_auto_adapt_is_locked' in value) || value['adaptive_shared_auto_adapt_is_locked'] === undefined) return false;
    if (!('adaptive_shared_auto_adapt_locked_to_value' in value) || value['adaptive_shared_auto_adapt_locked_to_value'] === undefined) return false;
    if (!('adaptive_voltage_next_alert_size_is_locked' in value) || value['adaptive_voltage_next_alert_size_is_locked'] === undefined) return false;
    if (!('adaptive_voltage_next_alert_size_locked_to_value' in value) || value['adaptive_voltage_next_alert_size_locked_to_value'] === undefined) return false;
    if (!('adaptive_current_next_alert_size_is_locked' in value) || value['adaptive_current_next_alert_size_is_locked'] === undefined) return false;
    if (!('adaptive_current_next_alert_size_locked_to_value' in value) || value['adaptive_current_next_alert_size_locked_to_value'] === undefined) return false;
    if (!('adaptive_voltage_max_setting' in value) || value['adaptive_voltage_max_setting'] === undefined) return false;
    if (!('adaptive_voltage_min_setting' in value) || value['adaptive_voltage_min_setting'] === undefined) return false;
    if (!('adaptive_current_max_setting' in value) || value['adaptive_current_max_setting'] === undefined) return false;
    if (!('adaptive_current_min_setting' in value) || value['adaptive_current_min_setting'] === undefined) return false;
    if (!('should_force_apply_this_update' in value) || value['should_force_apply_this_update'] === undefined) return false;
    return true;
}

export function AddPvdConfigRequestFromJSON(json: any): AddPvdConfigRequest {
    return AddPvdConfigRequestFromJSONTyped(json, false);
}

export function AddPvdConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddPvdConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'is_compass_core': json['is_compass_core'],
        'voltage_allowed_settings': json['voltage_allowed_settings'],
        'adaptive_voltage_allowed': json['adaptive_voltage_allowed'],
        'current_allowed_settings': json['current_allowed_settings'],
        'adaptive_current_allowed': json['adaptive_current_allowed'],
        'adaptive_shared_auto_adapt_is_locked': json['adaptive_shared_auto_adapt_is_locked'],
        'adaptive_shared_auto_adapt_locked_to_value': json['adaptive_shared_auto_adapt_locked_to_value'],
        'adaptive_voltage_next_alert_size_is_locked': json['adaptive_voltage_next_alert_size_is_locked'],
        'adaptive_voltage_next_alert_size_locked_to_value': json['adaptive_voltage_next_alert_size_locked_to_value'],
        'adaptive_current_next_alert_size_is_locked': json['adaptive_current_next_alert_size_is_locked'],
        'adaptive_current_next_alert_size_locked_to_value': json['adaptive_current_next_alert_size_locked_to_value'],
        'adaptive_voltage_max_setting': json['adaptive_voltage_max_setting'],
        'adaptive_voltage_min_setting': json['adaptive_voltage_min_setting'],
        'adaptive_current_max_setting': json['adaptive_current_max_setting'],
        'adaptive_current_min_setting': json['adaptive_current_min_setting'],
        'should_force_apply_this_update': json['should_force_apply_this_update'],
    };
}

export function AddPvdConfigRequestToJSON(json: any): AddPvdConfigRequest {
    return AddPvdConfigRequestToJSONTyped(json, false);
}

export function AddPvdConfigRequestToJSONTyped(value?: AddPvdConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'is_compass_core': value['is_compass_core'],
        'voltage_allowed_settings': value['voltage_allowed_settings'],
        'adaptive_voltage_allowed': value['adaptive_voltage_allowed'],
        'current_allowed_settings': value['current_allowed_settings'],
        'adaptive_current_allowed': value['adaptive_current_allowed'],
        'adaptive_shared_auto_adapt_is_locked': value['adaptive_shared_auto_adapt_is_locked'],
        'adaptive_shared_auto_adapt_locked_to_value': value['adaptive_shared_auto_adapt_locked_to_value'],
        'adaptive_voltage_next_alert_size_is_locked': value['adaptive_voltage_next_alert_size_is_locked'],
        'adaptive_voltage_next_alert_size_locked_to_value': value['adaptive_voltage_next_alert_size_locked_to_value'],
        'adaptive_current_next_alert_size_is_locked': value['adaptive_current_next_alert_size_is_locked'],
        'adaptive_current_next_alert_size_locked_to_value': value['adaptive_current_next_alert_size_locked_to_value'],
        'adaptive_voltage_max_setting': value['adaptive_voltage_max_setting'],
        'adaptive_voltage_min_setting': value['adaptive_voltage_min_setting'],
        'adaptive_current_max_setting': value['adaptive_current_max_setting'],
        'adaptive_current_min_setting': value['adaptive_current_min_setting'],
        'should_force_apply_this_update': value['should_force_apply_this_update'],
    };
}

